import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";
import Loader from "designs/v1/pages/ModifyKyc/components/Loader";

const Home = ({ stageScreen, setStageScreen }) => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const initialValues = {
    request_type: "",
  };
  const validationSchema = Yup.object().shape({
    request_type: Yup.array().min(1),
  });

  const requestOption = [
    {
      name: "Reactivation",
      value: "ReactivationType",
    },
    {
      name: "Modification",
      value: "ModificationType",
    },
  ];

  useEffect(() => {
    const user = sessionStorage.getItem("user");
    if (!user) {
      return history.push("/");
    }
  }, [history]);

  const handleSubmit = (value) => {
    console.log(value);
    if (value.request_type.length > 1) {
      const sortArr = value.request_type.sort().reverse();
      setStageScreen(sortArr[0]);
      localStorage.setItem("RequestTypeStage", JSON.stringify(sortArr));
    } else {
      setStageScreen(value.request_type[0]);
    }
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <Title title="ReKyc" />
      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <div className="mb-2">
              <Formik
                enableReinitialize={true}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ isValid, dirty, isSubmitting }) => (
                  <Form>
                    <div className="form-group my-2">
                      <Field
                        name="request_type"
                        className="form-control"
                      >
                        {({ field }) => {
                          return requestOption.map((option) => {
                            return (
                              <div key={option.name}>
                                <div>
                                  <input
                                    type="checkbox"
                                    {...field}
                                    value={option.value}
                                  />
                                  <label className="mx-2">{option.name}</label>
                                </div>
                              </div>
                            );
                          });
                        }}
                      </Field>
                    </div>
                    <div className="form-group my-4">
                      <Button
                        title="Next"
                        disabled={
                          !isValid || !dirty || isSubmitting || isLoading
                        }
                      />
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
